export default __webpack_public_path__ + "static/media/bg1.2b9ed584.png";